import { NgModule } from '@angular/core';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faChartLine, faChevronUp, faChevronDown, faBars, faFilter, faLink, faDownload, faCopy, faExternalLinkAlt,
  faTimes } from '@fortawesome/free-solid-svg-icons';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

@NgModule({
  imports: [ FontAwesomeModule ],
  exports: [ FontAwesomeModule ]
})
export class IconsModule {
  constructor(library: FaIconLibrary) {
    // add icons to the library for convenient access in other components
    library.addIcons(faChartLine, faChevronUp, faChevronDown, faBars, faFilter, faLink, faDownload, faQuestionCircle,
      faCopy, faExternalLinkAlt, faTimes);
  }
}
